import request from '@/api/request.js'

// 新增
export function SystemOrganizationInsert(data) {
    return request({
        url: '/api/organization/systemorganizationinsert',
        method: 'post',
        data: data
    })
}

// 删除
export function SystemOrganizationDelete(id) {
    return request({
        url: `/api/organization/systemorganizationdelete/${id}`,
        method: 'post',
        data: {}
    })
}

// 更新
export function SystemOrganizationUpdate(id, data) {
    return request({
        url: `/api/organization/systemorganizationupdate/${id}`,
        method: 'post',
        data: data
    })
}

// 获取
export function SystemOrganizationGetById(id) {
    return request({
        url: `/api/organization/getsystemorganizationbyid/${id}`,
        method: 'get',
        data: {}
    })
}

// 获取列表
export function SystemOrganizationGetList(params) {
    return request({
        url: '/api/organization/getsystemorganizationlist',
        method: 'get',
        params: params
    })
}

// 获取分页列表
export function SystemOrganizationGetPageList(params) {
    return request({
        url: '/api/organization/getsystemorganizationpagelist',
        method: 'get',
        params: params
    })
}